import client from 'graphql/client';
import { gql } from '@apollo/client';
import { ToolExecutionResult } from '../types';

const GET_USER_PREFERENCES = gql`
  query GetUserPreferences {
    portalClientPreferences {
      currency
      language
      firstLoginDate
      managementFeePayment
      annualManagementFeePayType
      historicManagementFeePayType
      bankTransferChaseEmailCount
      autoTrade
    }
  }
`;

export const executeGetUserPreferences = async (): Promise<ToolExecutionResult> => {
  try {
    const result = await client.query({
      query: GET_USER_PREFERENCES,
      fetchPolicy: 'network-only',
    });

    const prefs = result.data?.portalClientPreferences;

    if (!prefs) {
      return {
        success: false,
        error: 'Unable to retrieve user preferences. Please ensure you are logged in.',
      };
    }

    return {
      success: true,
      data: {
        preferences: {
          currency: prefs.currency || 'GBP',
          language: prefs.language || 'en',
          firstLoginDate: prefs.firstLoginDate,
          autoTrade: prefs.autoTrade,
          feePaymentSettings: {
            managementFeePayment: prefs.managementFeePayment,
            annualManagementFeePayType: prefs.annualManagementFeePayType,
            historicManagementFeePayType: prefs.historicManagementFeePayType,
          },
        },
      },
    };
  } catch (error) {
    return {
      success: false,
      error: `Failed to fetch user preferences: ${(error as Error).message}`,
    };
  }
};
